import React, { useState } from 'react';
import { Button, useToast } from '@chakra-ui/react';
import { client } from '@php-beam/packages/frontend/src/api/client';

export default function SetupBillingButton({
  leadId,
  onDone,
}: {
  leadId: number;
  onDone: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const setup = async () => {
    setLoading(true);
    try {
      const res = await client.post<{ card_id: number; last_four: string }>(
        `/devtools/documents/lead/${leadId}/billing`,
      );
      toast({
        title: 'Billing set up',
        description: `Card ending ${res.data.last_four}`,
        status: 'success',
        duration: 3000,
      });
      onDone();
    } catch (err: any) {
      toast({
        title: 'Failed to set up billing',
        description: err?.response?.data?.message || 'Unknown error',
        status: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button size="sm" colorScheme="orange" onClick={setup} isLoading={loading}>
      Setup Sandbox Billing
    </Button>
  );
}
